import { defineComponent as n, useCssModule as c, createBlock as a, openBlock as s, TransitionGroup as l, normalizeClass as i, unref as e, withCtx as u, createElementBlock as m, Fragment as _, renderList as p } from "vue";
import d from "./useToasts.js";
import f from "./Toast.js";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const k = /* @__PURE__ */ n({
  __name: "Toasts",
  setup(v) {
    const o = d(), r = c();
    return (y, B) => (s(), a(l, {
      "aria-atomic": "true",
      "aria-live": "polite",
      name: "toasts",
      tag: "ul",
      class: i([e(r).root, "stash-toasts"]),
      "data-test": "stash-toasts"
    }, {
      default: u(() => [
        (s(!0), m(_, null, p(e(o).active, (t) => (s(), a(f, {
          key: t.id,
          text: t.text,
          status: t.status,
          onClick: (M) => e(o).remove(t.id)
        }, null, 8, ["text", "status", "onClick"]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), C = "_root_1m7jr_2", T = {
  root: C
}, h = {
  $style: T
}, z = /* @__PURE__ */ x(k, [["__cssModules", h]]);
export {
  z as default
};
//# sourceMappingURL=Toasts.js.map
